import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query'
import { api } from "lib/utils"

// const getExternal = (args:any) => {
//   return 
//     fetch(args.path)
// }

const getCollection = (args:any) => {
  return useQuery({
    queryKey: [`${args.resource}${args.modifier ? `.${args.modifier}` : ''}.all`],
    queryFn: () => {
      const payload:any = api.findAll({ resource: args.resource, params: args.params })
      return payload
    },
    enabled: !!args.enabled || true
  })
}

const getOne = (args:any) => {
  return useQuery({
    queryKey: [`${args.resource}.one${args.modifier ? `.${args.modifier}` : ''}`],
    queryFn: () => {
      const payload:any = api.findOne({ resource: args.resource, ...args })
      return payload
    },
    enabled: !!args.params
  })
}

const getById = (args:any) => {
  return useQuery({
    queryKey: [`${args.resource}.single.${args._id}`],
    queryFn: () => {
      const payload = api.findById({ resource: args.resource, _id: args._id, params: args.params })
      return Array.isArray(payload) ? payload[0] : payload
    },
    enabled: !!args._id
  })
}

const useSaveResource = (invalidate:string[] = [], callbackFn?:any) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (args:any) => {
      const result = api.save({ resource: args.resource, data: args.data })
      return result
    },
    onSuccess: (data, args) => {
      queryClient.invalidateQueries({queryKey: invalidate})
      if( callbackFn ) {
        console.log("callbackFn", data)
        callbackFn(data)
      }
      return data
    }
  })
}

export const appTools = {
  resource: {
    getCollection,
    getById,
    getOne,
    save: useSaveResource
  }
}